import { Button } from '../button/Button';
import { withPersonalizedButtonStyle } from '../button/withPersonalizedButtonStyle';
import { styles } from './QuaternaryOnDarkButton.styles';

export const QuaternaryOnDarkButton = withPersonalizedButtonStyle(Button, styles);
